import { ws } from "../../../utils/common";

export const getUserInfo = async () => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "user/",
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data;
  }
};

export const deleteUserWS = async () => {
  const res = await ws(
    "DELETE",
    process.env.REACT_APP_ENDPOINT + "user/",
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data;
  }
};

export const checkDeviceWS = async ({ endpoint }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "device/check-device",
    { endpoint },
    null,
    true
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data;
  }
};

export const deleteDeviceWS = async ({ endpoint }) => {
  const res = await ws(
    "DELETE",
    process.env.REACT_APP_ENDPOINT + "device/",
    null,
    { endpoint },
    true
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data;
  }
};
